import * as React from "react";

import { Redirect } from "react-router-dom";

import { Box, Typography } from "@material-ui/core";

import { Page } from "../Page";
import { IPageProps } from "../IPageProps";

import { HomeRoute } from "Routes";

import { QuiltThumbnail } from "Components/QuiltThumbnail";
import { RequestProgress } from "Components/RequestProgress";

import { IFavoriteQuilt } from "Model/IFavoriteQuilt";

import { Status, useHttpGet } from "Utility/useHttp";

import { DeleteButton } from "./DeleteButton";


function renderFavorites(
    props: IPageProps,
    favorites: IFavoriteQuilt[] | null,
    setFavorites: (f: IFavoriteQuilt[]) => void): React.ReactElement | null {

    if (favorites === null) {
        return null;
    }

    const onDeleted = (index: number) => {
        const favCopy = [...favorites];

        favCopy.splice(index, 1);

        setFavorites(favCopy);
    };

    const items = favorites.map((f, index) => {
        const thumbnailUrl = `${props.user!.id}/${f.id}.png`;

        return (
            <Box p={1} key={f.id} display="flex" flexDirection="column" alignItems="center">
                <QuiltThumbnail code={f.code} thumbnailUrl={thumbnailUrl} />

                <DeleteButton user={props.user} favorite={f} onDeleted={() => onDeleted(index)}/>
            </Box>
        )
    });

    if (items.length === 0) {
        items.push(<Typography key="none">No favorites.</Typography>);
    };

    return (
        <Box display="flex" flexDirection="row" justifyContent="center" flexWrap="wrap">
            {items}
        </Box>
    )
}

export function FavoritesPage(props: IPageProps): React.ReactElement {
    const request = useHttpGet<IFavoriteQuilt[]>("api/favorites", props.user);

    const [favorites, setFavorites] = React.useState<IFavoriteQuilt[] | null>(null);

    React.useEffect(() => {
        if (request.status !== Status.Complete) {
            return;
        }

        request.data.sort((a, b) => b.addedDateUtc.localeCompare(a.addedDateUtc));

        setFavorites(request.data);
    },
    [request])

    if (props.user === undefined) {
        return <Redirect to={HomeRoute.path} />;
    }

    return (
        <Page>
            <Box mb={2}>
                <Typography variant="h5">Saved quilts</Typography>
            </Box>
            
            <RequestProgress request={request} errorMessage="Failed to load favorites." />
            {renderFavorites(props, favorites, setFavorites)}
        </Page>
    );
}